import { render, staticRenderFns } from "./ThankYouModal.vue?vue&type=template&id=475e7a87&scoped=true&"
import script from "./ThankYouModal.vue?vue&type=script&lang=js&"
export * from "./ThankYouModal.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouModal.vue?vue&type=style&index=0&id=475e7a87&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e7a87",
  null
  
)

export default component.exports